import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { RolePermission } from '../models/models.lib';
import { SettingsService } from '../settings/settings.service';
import { ApiService } from '../api/api.service';
import { Settings } from '../common/obj.lib';

export abstract class CasiRolePermissionService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(roleId: number): void {
    this.fetch(roleId)
      .subscribe((x) => {
        // console.log('query: x: ', x);
        return super.next(x);
      });
  }

  protected fetch(id: number): Observable<RolePermission[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();

    return this.http.get(encodeURI(`${this.settings.apiUrl}/rolespermissions/${id}`))
      .pipe(
        map((response: any, i) => <RolePermission[]>response),
        map(r => r.map(x => RolePermission.create(x))),
        // tap(nr => {
        //   console.log('nr: ', nr);
        // }),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class RolePermissionService  extends CasiRolePermissionService {

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService
  ) {
    super(http, settingService);
  }

  get() {
    return this.apiService.getHttpCall('rolespermissions', 'get');
  }

  getById(id: number) {
    return this.apiService.getHttpCall(`rolespermissions/${id}`, 'getById');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('rolespermissions', p, 'add');
  }

  update(id:number, p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`rolespermissions/${id}`, p, 'update');
  }

  destroy(roleId: number, permissionId: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`rolespermissions/${roleId}/${permissionId}`, 'destroy');
  }


}
